import { render, staticRenderFns } from "./AllClinic.vue?vue&type=template&id=31510ff4"
import script from "./AllClinic.vue?vue&type=script&lang=js"
export * from "./AllClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports